import memoize from 'nano-memoize';
import {displayCountryName} from '@common/ui/country/country-display';

export const getCountryList = memoize(
  (lang = 'en'): {code: string; name: string}[] => {
    const A = 65;
    const Z = 90;
    // Enumerate via Intl (to discover which 2-letter pairs are real countries),
    // but take the DISPLAY name from `displayCountryName` so NAME_OVERRIDES wins
    // — otherwise CN reads "China mainland" on newer ICU builds.
    const countryName = new Intl.DisplayNames([lang], {type: 'region'});
    const countries: {code: string; name: string}[] = [];
    for (let i = A; i <= Z; ++i) {
      for (let j = A; j <= Z; ++j) {
        const code = String.fromCharCode(i) + String.fromCharCode(j);
        const name = countryName.of(code);
        if (code !== name && name) {
          countries.push({code: code.toLowerCase(), name: displayCountryName(code, name, lang)});
        }
      }
    }
    return countries;
  },
);
